module.exports = __webpack_public_path__ + "img/kiss_scene.40793b9a.jpg";